export default __webpack_public_path__ + "static/media/surge.d89cf91c.svg";